<script>
export default {
    name: 'DesignSubTable',
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: [Array, Object],
            default: () => [],
        },
        eventCode: {
            type: String,
            default: '',
        },
        viewCode: {
            type: String,
            default: '',
        }
    },
    data () {
        return {

        }
    },
    watch: {},
    render() {
        const { formSlot: { scopedSlots }, design } = this.$attrs
        const { eventCode, viewCode } = this
        const add = () => {}
        const del = () => {}
        const upload = () => {}
        return (
            <div>
                {
                    design ? 
                    (
                        <el-skeleton rows={3} />
                    ) :
                    scopedSlots.DesignSubTable ? 
                        scopedSlots.DesignSubTable({
                            eventCode,
                            viewCode,
                            action: {
                                add,
                                del,
                                upload
                            }
                        }) : null
                }
            </div>
        )
    }
}
</script>